import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './static-pages-navigation.magic.css.js';
import script from './static-pages-navigation.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMobile)?_c('div',{staticClass:"static-pages-navigation",attrs:{"part":"static-pages-navigation","data-v-test-id":"static-pages-navigation"}},[_c('div',{staticClass:"navigation-wrapper",attrs:{"part":"navigation-wrapper"}},[(_vm.isMobileCategoy)?_vm._l((_vm.pages),function(page){return _c('div',{key:page.id,staticClass:"navigation-item",class:{
                    'is-category-item': _vm.isMobileCategoy,
                    'is-active': _vm.isActive(page),
                    'has-white-overlay': _vm.hasWhiteOverlay(page)
                },attrs:{"part":_vm.$p('navigation-item', 
                          [{
                              'is-category-item': _vm.isMobileCategoy,
                              'is-active': _vm.isActive(page),
                              'has-white-overlay': _vm.hasWhiteOverlay(page)
                          }])},on:{"click":function($event){return _vm.handleRedirectToLink(page)}}},[(page.background)?_c('magic-ui-background',{staticClass:"navigation-item--bg",attrs:{"part":"navigation-item--bg","path":page.background,"alt":page.title,"img-fit":"max","heights":"1,1,1,1,1,1"}}):_c('div',{staticClass:"navigation-item--bg navigation-item--default-bg",attrs:{"part":"navigation-item--bg navigation-item--default-bg"}}),_vm._v(" "),_c('div',{staticClass:"navigation-item--content",attrs:{"part":"navigation-item--content"}},[_c('magic-ui-icon',{staticClass:"icon navigation-item--icon",attrs:{"name":page.content,"part":"icon navigation-item--icon"}}),_vm._v(" "),_c('div',{staticClass:"navigation-item--titles",attrs:{"part":"navigation-item--titles"}},[_c('span',{staticClass:"navigation-item--title",attrs:{"part":"navigation-item--title"}},[_vm._v(_vm._s(page.title))])])],1)],1)}):_vm._e(),_vm._v(" "),(!_vm.isMobileCategoy && _vm.page)?_c('div',{staticClass:"navigation-item is-single-item",attrs:{"part":"navigation-item is-single-item"},on:{"click":function($event){return _vm.handleRedirectToLink(_vm.page)}}},[(_vm.page.background)?_c('magic-ui-background',{staticClass:"navigation-item--bg",attrs:{"part":"navigation-item--bg","path":_vm.page.background,"alt":_vm.page.title,"img-fit":"max","heights":"1,1,1,1,1,1"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"navigation-item--content",attrs:{"part":"navigation-item--content"}},[_c('magic-ui-icon',{staticClass:"icon navigation-item--icon",attrs:{"name":_vm.page.content,"part":"icon navigation-item--icon"}}),_vm._v(" "),_c('div',{staticClass:"navigation-item--titles",attrs:{"part":"navigation-item--titles"}},[_c('span',{staticClass:"navigation-item--title",attrs:{"part":"navigation-item--title"}},[_vm._v(_vm._s(_vm.page.title))])])],1)],1):_vm._e()],2)]):_vm._e()};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-57800d48_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-57800d48";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
